import { buildSearchParamsString } from '@/helpers/searchHospitalListingsHelper';
import { SearchHospitalsType } from '@/schemas/SearchParamsSchemas/app/stations/search/hospitals/Schema';
import { STATION_SORTS } from '@/types/types';
import { useRouter } from 'next/navigation';
import { useTransition } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  isPublicSearch: boolean;
};

export const useLogic = ({ isPublicSearch }: Props) => {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const { control, setValue, getValues } =
    useFormContext<SearchHospitalsType>();

  const handleChangeSorts = (value: unknown) => {
    const targetSorts = STATION_SORTS.find((s) => s.value === value);
    if (targetSorts) {
      setValue('sort', targetSorts.value);
      const formValues = getValues();
      // NOTE: ページをリセットしておく
      formValues.page = 1;
      const searchParams = buildSearchParamsString({ formValues });

      startTransition(() => {
        router.push(
          `/${
            isPublicSearch ? 'public' : 'app'
          }/stations/search?${searchParams}`,
        );
      });
    }
  };

  return {
    control,
    handleChangeSorts,
    isPending,
  };
};
